import { Injectable } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { Utils } from '../utils';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/app/app.settings';
import { ActivatedRoute } from '@angular/router';
import { AppData } from 'src/app/app.data';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModulesService {

  settings: Settings;
    apiEndPoint: string = Utils.getApiEndPoint(); // environment.APIEndpoint;
    

  constructor(
    private http: HttpClient,
        private appSettings: AppSettings,
        private route: ActivatedRoute,
        private appData: AppData
  ) { 
    this.settings = appSettings.settings;
  }

  isWhatsAppEnabled(branchID: number = 0){
      return this.http.get<any>(this.apiEndPoint + `ModuleApi/IsWhatsAppEnabled/${branchID}`)
      .pipe(map(result => {
        return result;
      }));
    }

}
